import { Api } from 'common/utils/api';
import { useMutation, useQueryClient } from 'react-query';

export interface DeleteCompanyRequest {
    id: number;
}

export const useDeleteCompany = () => {
    const queryClient = useQueryClient();

    const deleteCompany = useMutation((data: DeleteCompanyRequest) => Api.delete({ path: `/partners/${data.id}` }), {
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['partners', 'list'] });
        },
    });
    return {
        deleteCompany: deleteCompany.mutateAsync,
    };
};
